import React from 'react';
import { observer, inject } from 'mobx-react';
import { Route, Redirect } from 'react-router-dom';

export default inject('userStore')(
  observer(({ userStore, ...rest }) => {
    if (userStore.self) {
      console.log(`ProtectedRoute.js. userStore.self is defined ...`)
      return <Route {...rest} />;
    }

    console.log(`ProtectedRoute.js. userStore.self is undefined ... show login page`)

    var u = new URLSearchParams(window.location.search).get("dataset")
    // return <Redirect to='/login?dataset='+u />;
    return <Redirect to={`/login?dataset=${u}`} />;
  })
);



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute.js